<template>

  <div class="head-grid-container">

    <div>
      <img class="head-logo-circle" src="../assets/LogoCircle.png">
    </div>
    <div>
      <img class="head-logo-name" src="../assets/LogoName.jpg">
    </div>

    <div>
      <router-link to="/"> 
      <button class="home-button">Home</button>
      </router-link>
    </div>

    <div>
      <router-link to="/Menu"> 
      <button class="menu-button">Menu</button>
      </router-link>
    </div>

    <div>
      <router-link to="/Catering"> 
      <button class="catering-button">Catering</button>
      </router-link>
    </div>

  </div>

</template>


<script>

  export default {
    name: 'MenuHeader2'
  }

</script>
  
<style scoped>

/* for grand screen (14.75 inches and above) */
@media (min-width:1601px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: -50px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -140px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}


/* for bigger screen (13.25 to 14.75 inches of screen) */
@media (min-width:1451px) and (max-width: 1600px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: -40px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -120px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}

/* for bigger desktop (12 to 13.25 inches of screen) */
@media (min-width:1301px) and (max-width: 1450px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: -35px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -110px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}


/* for desktop (10.75 to 12 inches of screen) */
@media (min-width:1151px) and (max-width: 1300px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: -25px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -100px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}


/* for laptop (9.25-10.75 inches of screen) */
@media (min-width:1001px) and (max-width:1150px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: -10px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -90px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}

/* for bigger ipad (8-9.25 inches of screen) */
@media (min-width:851px) and (max-width:1000px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: 2px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -90px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}

/* for ipad (6.5-8 inches of screen) */
@media (min-width:701px) and (max-width:850px) {

.head-grid-container {
    position: relative;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
    width: 100%;
    height: 80px;
  }

.head-logo-circle {
    display: grid;
    justify-items: start;
    width: 65px;
    height: 65px;
    margin-top: 10px;
    aspect-ratio: 1 / 1;
  }

.head-logo-name {
    display: grid;
    justify-items: start;
    width: 150px;
    height: 65px;
    margin-top: 10px;
    margin-left: 5px;
  }

.home-button, .menu-button, .catering-button {
    display: grid;
    justify-items: center;
    width: 100px;
    height: 30px;
    margin-top: 30px;
    margin-left: -50px;
    background-color: #fff7b8;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
}

/* for Phone (up to 6.5 inches of screen) */
@media (max-width:700px) {

.head-logo-circle {
    width: 5rem;
    height: 5rem;
    margin-top: 1rem;
    aspect-ratio: 1 /1;
  }

.head-logo-name {
    width: 10rem;
    height: 5rem;
    margin-bottom: 0.5rem;
  }

.home-button, .menu-button, .catering-button {
    justify-items: center;
    width: 6rem;
    height: auto;
    margin-top: 0.5rem;
    color: darkblue;
    font-weight: bold;
    font-size: 1.2rem;
    cursor: pointer;
  }

}
  
</style>